import {BACKEND_ENDPOINT} from '../../Constants'
import axiosInstance from '../../config/AxiosConfig'

export function getClientRoleList(userId, dto, filterRequest) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/role/getList`, filterRequest, {
            params: {userId, dto},
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}

export function getUserRoleInfo(userId, hospitalId) {
    return axiosInstance
        .post(`${BACKEND_ENDPOINT}/userRole/getUserRoleInfo`, null, {
            params: {userId, hospitalId},
        })
        .then(res => (res.data ? res.data : null))
        .catch(error => console.log(error))
}
